import { useNavigation } from 'react-router-dom';

import { routeLoadingClassName } from 'theme/routeLoading';

export function useTrackNavigationState() {
  const { state } = useNavigation();
  if (typeof window !== 'undefined') {
    const isLoading = state === 'loading';
    window.loadingRoute = isLoading;

    if (isLoading) {
      document.body.classList.add(routeLoadingClassName);
    } else {
      document.body.classList.remove(routeLoadingClassName);
    }
  }
}
